import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FireflyChartBoilerplateModule } from '../common/chart-boilerplate/chart-boilerplate.module';
import { FireflyLineModule } from '../common/lines/line/line.module';
import { FireflyStackedBarSeriesModule } from '../common/stacked-bar-series/stacked-bar-series.module';
import { FireflyStackedBarLineChartComponent } from './stacked-bar-line-chart.component';

@NgModule({
  imports: [CommonModule, FireflyLineModule, FireflyStackedBarSeriesModule, FireflyChartBoilerplateModule],
  declarations: [FireflyStackedBarLineChartComponent],
  exports: [FireflyStackedBarLineChartComponent]
})
export class FireflyStackedBarLineChartModule {}
